var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7D2248",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.151 500c138.071 0 250-111.929 250-250S388.222 0 250.151 0 .151367 111.929.151367 250 112.08 500 250.151 500Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.584 164.824v24.01h13.167v-24.01h195.437v42.529c-20.591 3-36.403 20.729-36.403 42.151 0 21.422 15.812 39.152 36.403 42.152v42.27H185.751v-22.719h-13.167v22.719h-53.183v-42.273c20.589-3 36.402-20.727 36.402-42.149s-15.813-39.15-36.402-42.151v-42.529h53.183Zm0 34.853h13.167v26.333h-13.167v-26.333Zm0 74.353h13.167v26.334h-13.167V274.03Zm13.167-37.177h-13.167v26.334h13.167v-26.334Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicket);
export default __webpack_public_path__ + "static/media/icon-ticket.dd5305dceaa7f87d13717aa4d5f429a6.svg";
export { ForwardRef as ReactComponent };